import {Inject, Injectable} from '@angular/core';
import {CanActivate} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import {MyDialogPopupLoginComponent} from '../../component/popup/popup-login/popup-login.component';
import {Config, WEB_CONFIG} from '../../config';
import {Observable} from 'rxjs';

@Injectable()
export class LoginGuard implements CanActivate {
  public apiUrl: string;

  constructor(
    private http: HttpClient,
    private translateService: TranslateService,
    private dialog: MatDialog,
    @Inject(WEB_CONFIG) private config: Config
  ) {
    this.apiUrl = config.api_url + '/authorization-api/';
  }

  public canActivate(): boolean | Observable<boolean> {
    if (sessionStorage.getItem('authToken') !== null) {
      return true;
    } else {
      const dialogRef = this.dialog.open(MyDialogPopupLoginComponent, {disableClose: true});
      return dialogRef.afterClosed();
    }
  }
}
